import { useState } from 'react';
import './CommercialBrands.css';
import savesUnderline from '../../assets/figma_saves_underline.svg';
import checkDecagram from '../../assets/figma_check_decagram.svg';

import sungrowLogo from '../../assets/brand_sungrow.svg';
import solaxLogo from '../../assets/brand_solax.png';

import sungrowImg from '../../assets/com_sungrow_commercial.png';
import solaxImg from '../../assets/com_solax_commercial.png';

const brands = [
  {
    id: 'sungrow',
    tab: 'Sungrow',
    logo: sungrowLogo,
    logoClass: 'cbrands-logo--svg',
    product: 'Sungrow SBR Series',
    desc: 'Commercial-grade battery system designed for reliability and long-term performance.',
    img: sungrowImg,
  },
  {
    id: 'solax',
    tab: 'SolaX',
    logo: solaxLogo,
    logoClass: 'cbrands-logo--png',
    product: 'SolaX T-BAT Series',
    desc: 'Commercial-grade battery system designed for reliability and long-term performance.',
    img: solaxImg,
  },
];

const reasons = [
  'Proven Performance',
  'Commercial Applications',
  'Warranty Support',
  'Australian Market Presence',
];

export default function CommercialBrands() {
  const [active, setActive] = useState(0);
  const brand = brands[active];

  return (
    <section className="cbrands-section">
      <div className="cbrands-inner">

        {/* Top: title full width, then desc left + tabs right */}
        <div className="cbrands-top">
          <h2 className="cbrands-title">
            Trusted Commercial{' '}
            <span className="cbrands-title-accent">
              Battery Solutions
              <img src={savesUnderline} alt="" className="cbrands-accent-stroke" />
            </span>
          </h2>
          <div className="cbrands-top-row">
            <p className="cbrands-desc">High-performance battery systems from trusted global brands.</p>
            <div className="cbrands-tabs">
              {brands.map((b, i) => (
                <button
                  key={b.id}
                  className={`cbrands-tab${active === i ? ' cbrands-tab--active' : ''}`}
                  onClick={() => setActive(i)}
                >
                  {b.tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="cbrands-content">

          {/* Left: product card */}
          <div className="cbrands-card">
            <div className="cbrands-card-left">
              <img src={brand.logo} alt={brand.tab} className={`cbrands-logo ${brand.logoClass}`} />
              <div className="cbrands-card-text">
                <h3 className="cbrands-product-name">{brand.product}</h3>
                <p className="cbrands-product-desc">{brand.desc}</p>
              </div>
            </div>
            <div className="cbrands-card-right">
              <img src={brand.img} alt={brand.product} className="cbrands-product-img" />
            </div>
          </div>

          {/* Right: reasons */}
          <div className="cbrands-reasons">
            <h4 className="cbrands-reasons-title">WHY BUSINESSES CHOOSE THESE BRANDS</h4>
            <div className="cbrands-reasons-underline" />
            <ul className="cbrands-reasons-list">
              {reasons.map((r, i) => (
                <li key={i} className="cbrands-reason-item">
                  <img src={checkDecagram} alt="check" className="cbrands-check" />
                  <span>{r}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
